import { render, staticRenderFns } from "./RoomSelectorG.vue?vue&type=template&id=534e9d36&"
import script from "./RoomSelectorG.vue?vue&type=script&setup=true&lang=js&"
export * from "./RoomSelectorG.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports